(() => {
  // Coordinates follow the three existing square product photographs.
  // The 20-pack photograph depicts 24 circles; all visible circles remain usable.
  const profiles = [
    { columns: [87.5], rows: [29.2, 50, 70.8], size: 17, worlds: ['galaxia', 'nebulosa', 'agujero-negro'] },
    { columns: [73.85, 90.55], rows: [9.85, 25.85, 41.85, 57.85, 73.85, 89.85], size: 12.1,
      worlds: ['saturno', 'galaxia', 'nebulosa', 'constelaciones', 'oceano', 'luna', 'aurora', 'jupiter', 'medusas', 'agujero-negro', 'agujero-negro', 'jupiter'] },
    { columns: [61.75, 75.9, 90], rows: [8.3, 20.3, 32.2, 44.1, 56, 67.9, 80, 92], size: 8.1,
      worlds: ['aurora', 'galaxia', 'agujero-negro', 'luna', 'agujero-negro', 'pilares', 'constelaciones', 'luna', 'nebulosa', 'constelaciones', 'galaxia', 'galaxia', 'agujero-negro', 'saturno', 'oceano', 'luna', 'constelaciones', 'agujero-negro', 'saturno', 'jupiter', 'pilares', 'nebulosa', 'oceano', 'medusas'] }
  ];

  const init = (scope = document) => {
    const selector = '[data-packs]:not([data-pack-worlds-ready])';
    const sections = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) sections.unshift(scope);
    sections.forEach((section) => {
      const stage = section.querySelector('[data-pack-world-stage]');
      const packImage = section.querySelector('[data-pack-image]');
      const options = [...section.querySelectorAll('[data-pack-option]')];
      if (!stage || !packImage || options.length < 3) return;
      section.setAttribute('data-pack-worlds-ready', '');

      const choices = stage.querySelector('.galix-pack-worlds__choices');
      const layers = [...stage.querySelectorAll('[data-pack-world-scene-layer]')];
      const announcement = stage.querySelector('[data-pack-world-announcement]');
      const media = new Map([...stage.querySelectorAll('[data-pack-world-asset]')].map((item) => [item.dataset.key, { name: item.dataset.name, url: item.dataset.image }]));
      const loaded = new Map();
      let activeLayer = -1;
      let clickToken = 0;
      const text = (name, fallback, values = {}) => Object.keys(values).reduce((out, key) => out.split(`[${key}]`).join(values[key]), stage.dataset[name] || fallback);

      const preload = (url) => {
        if (!loaded.has(url)) {
          const image = new Image();
          image.src = url;
          loaded.set(url, image.decode ? image.decode().catch(() => {}) : new Promise((resolve) => {
            image.onload = resolve;
            image.onerror = resolve;
          }));
        }
        return loaded.get(url);
      };

      const reset = () => {
        clickToken += 1;
        activeLayer = -1;
        stage.classList.remove('is-active');
        layers.forEach((layer) => layer.classList.remove('is-active'));
        choices.querySelectorAll('[data-pack-world]').forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
        if (announcement) announcement.textContent = '';
      };

      const renderChoices = (profile, sourceImage) => {
        const selectedIndex = choices.querySelector('[aria-pressed="true"]')?.dataset.packWorldIndex;
        const frameWidth = stage.clientWidth;
        const frameHeight = stage.clientHeight;
        const imageWidth = packImage.naturalWidth;
        const imageHeight = packImage.naturalHeight;
        const fit = getComputedStyle(packImage).objectFit;
        const scale = (fit === 'contain' ? Math.min : Math.max)(frameWidth / imageWidth, frameHeight / imageHeight);
        const renderedWidth = imageWidth * scale;
        const renderedHeight = imageHeight * scale;
        const offsetX = (frameWidth - renderedWidth) / 2;
        const offsetY = (frameHeight - renderedHeight) / 2;
        const diameter = renderedWidth * profile.size / 100;
        const hitDiameter = Math.max(diameter, 38);
        const fragment = document.createDocumentFragment();
        profile.rows.forEach((y, row) => profile.columns.forEach((x, column) => {
          const index = row * profile.columns.length + column;
          const key = profile.worlds[index];
          const world = media.get(key);
          const button = document.createElement('button');
          const visual = document.createElement('span');
          const sprite = document.createElement('img');
          const circleLeft = offsetX + renderedWidth * x / 100 - diameter / 2;
          const circleTop = offsetY + renderedHeight * y / 100 - diameter / 2;
          const inset = (hitDiameter - diameter) / 2;
          button.type = 'button';
          button.className = 'galix-pack-worlds__choice';
          visual.className = 'galix-pack-worlds__choice-visual';
          button.dataset.packWorld = key;
          button.dataset.packWorldIndex = String(index);
          button.setAttribute('aria-label', text('txtView', 'Ver proyección [name]', { name: world?.name || text('txtChip', 'Ficha [number]', { number: index + 1 }) }));
          button.setAttribute('aria-pressed', String(selectedIndex === String(index)));
          button.style.left = `${circleLeft - inset}px`;
          button.style.top = `${circleTop - inset}px`;
          button.style.width = `${hitDiameter}px`;
          visual.style.left = `${inset}px`;
          visual.style.top = `${inset}px`;
          visual.style.width = `${diameter}px`;
          visual.style.height = `${diameter}px`;
          sprite.src = sourceImage;
          sprite.alt = '';
          sprite.draggable = false;
          sprite.style.width = `${renderedWidth}px`;
          sprite.style.height = `${renderedHeight}px`;
          sprite.style.left = `${offsetX - circleLeft}px`;
          sprite.style.top = `${offsetY - circleTop}px`;
          visual.append(sprite);
          button.append(visual);
          fragment.append(button);
        }));
        choices.replaceChildren(fragment);
      };

      const syncPack = () => {
        const index = options.findIndex((option) => option.dataset.variantId === section.dataset.selectedVariant);
        const option = options[index];
        const sourceImage = option?.dataset.image ? new URL(option.dataset.image, location.href).href : '';
        const ready = index >= 0 && sourceImage && packImage.src === sourceImage && packImage.complete && packImage.naturalWidth > 0;
        stage.classList.toggle('is-available', Boolean(ready));
        if (!ready) { reset(); return; }
        if (stage.dataset.packIndex !== String(index) || stage.dataset.sourceImage !== sourceImage) {
          reset();
          stage.dataset.packIndex = String(index);
          stage.dataset.sourceImage = sourceImage;
          stage.setAttribute('aria-label', text('txtStageOf', 'Vista previa de las fichas de [name]', { name: option.textContent.trim() }));
          choices.setAttribute('aria-label', text('txtChoicesOf', 'Prueba las fichas de [name]', { name: option.textContent.trim() }));
          renderChoices(profiles[index], sourceImage);
        }
      };

      const activate = (choice) => {
        if (!stage.classList.contains('is-available')) return;
        const world = media.get(choice.dataset.packWorld);
        if (!world) return;
        const token = ++clickToken;
        preload(world.url).then(() => {
          if (token !== clickToken || !stage.classList.contains('is-available')) return;
          const nextLayer = activeLayer === 0 ? 1 : 0;
          const previousLayer = activeLayer;
          layers[nextLayer].style.backgroundImage = `url("${world.url}")`;
          requestAnimationFrame(() => {
            if (token !== clickToken) return;
            stage.classList.add('is-active');
            layers[nextLayer].classList.add('is-active');
            if (previousLayer >= 0) layers[previousLayer].classList.remove('is-active');
            activeLayer = nextLayer;
            choices.querySelectorAll('[data-pack-world]').forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
            if (announcement) announcement.textContent = text('txtPreview', 'Vista previa: [name].', { name: world.name });
          });
        });
      };

      choices.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-pack-world]');
        if (choice && choices.contains(choice)) activate(choice);
      });
      choices.addEventListener('pointerover', (event) => {
        const world = media.get(event.target.closest('[data-pack-world]')?.dataset.packWorld);
        if (world) preload(world.url);
      });
      choices.addEventListener('focusin', (event) => {
        const world = media.get(event.target.closest('[data-pack-world]')?.dataset.packWorld);
        if (world) preload(world.url);
      });

      const variantObserver = new MutationObserver(syncPack);
      const imageObserver = new MutationObserver(syncPack);
      const resizeObserver = new ResizeObserver(() => {
        if (stage.classList.contains('is-available')) renderChoices(profiles[Number(stage.dataset.packIndex)], stage.dataset.sourceImage);
      });
      variantObserver.observe(section, { attributes: true, attributeFilter: ['data-selected-variant'] });
      imageObserver.observe(packImage, { attributes: true, attributeFilter: ['src'] });
      resizeObserver.observe(stage);
      packImage.addEventListener('load', syncPack);
      section.addEventListener('shopify:section:unload', () => {
        variantObserver.disconnect();
        imageObserver.disconnect();
        resizeObserver.disconnect();
        packImage.removeEventListener('load', syncPack);
      }, { once: true });
      syncPack();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
